export default {
  message: {
    longPressSaveTips: '请长按图片保存',
    noUser: '请输入联系人姓名/手机号/验证码',
    bookingSuccess: '预约成功',
    bookingFailed: '预约失败',
    phoneNumInvalid: '请输入有效的手机号码！'
  },
  placeholder: {
    enter: '请输入您喜欢的品牌'
  },
  activityInfo: {
    detail: '活动详情'
  },
  fullScreenPhoto: {
    showPic: '显示大图',
    downloading: '下载中',
    fileName: '文件名',
    fileSize: '尺寸',
    category: '分类',
    authorName: '摄影师'
  },
  functionBar: {
    all: '全部',
    newest: '最新',
    hot: '人气',
    category: '照片',
    video: '视频',
    arrange: '排序',
    merge: '拼图',

    video: '视频'
  },
  imagewall: {
    cancel: '取消',
    merge: '拼图',
    longPressSaveTips: '长按保存图片',
    sweepAndShareTips: '扫一扫分享此相册',
    product: '卡菲云相册',
    bookingTitle: '在线预约',
    bookingContacts: '请输入联系人姓名(必填)',
    bookingPhoneNum: '请输入手机号（必填）',
    bookingSmscode: '请输入验证码（必填）',
    bookingGetSmscode: '获取验证码',
    bookingRetrySmscode: '秒后重新获取',
    bookingCompany: '请输入公司名称（选填）',
    bookingDetail: '请输入拍摄需求，如时间、地点、活动规模等（选填）',
    bookingSubmit: '提交预约',

    selfieTitle: '自拍选图',
    selfieTipsInit1: '请上传单人正面照',
    selfieTipsInit2: '可快速查找相册里的照片',
    selfieTipsUploading: '正在识别中，请稍候...',
    selfieTipsFailed: '识别失败',
    selfieUpload: '上传照片',
    selfieReupload: '重新上传照片'
  },
  welcome: {
    into: '进入相册'
  }
}
